<template>
  <v-container fluid pa-4 background>
    <v-layout row wrap pa-3 style="background-color:#fff; margin:5px; border-radius:5px;">
      <!-- Create Button -->
      <v-tooltip top>
        <v-btn
          slot="activator"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="onHandleDialog(true, 'create', null)"
        >
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <span>{{$t('create')}}</span>
      </v-tooltip>
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md2 sm6 xs12 px-1>
            <v-select
              :items="Branch_List"
              :label="$t('branch')"
              item-text="name"
              item-value="code"
              v-model="branchSelect"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-select
              :items="Department_List"
              :label="$t('Department')"
              item-text="name"
              item-value="code"
              v-model="departmentSelect"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-text-field :label="$t('code')" type="text" v-model="emp_code" hide-details />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="success" @click="currentbutton()">
              <v-icon class="pr-2" size="16">fa-spinner</v-icon>
              <span>{{$t('processor')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="info" @click="printTable()">
              <v-icon class="pr-2" size="16">fa-print</v-icon>
              <span>{{$t('print')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="primary" @click="doCopyTable()">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{$t('copy')}}</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap my-3 class="hidden-xs-only content">
          <v-flex xs12>
            <v-btn dark color="teal" @click="checkbutton(0)">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark color="teal" @click="checkbutton(1)">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
          </v-flex>
        </v-layout> -->
      </v-flex>
      <v-layout row wrap ma-2>
        <v-flex xs12 class="hidden-xs-only">
          <v-layout row wrap>
            <v-flex md4 xs12 class="text-sm-left text-xs-left">
              <v-btn @click="todaybutton()" color="#039BE5" style="color:#fff;">
                <v-icon dark left color="#fff;">far fa-calendar-check</v-icon>
                {{$t('Today')}}
              </v-btn>
              <v-btn @click="prevmonth()">
                <v-icon dark left>keyboard_arrow_left</v-icon>
                {{$t('LastMount')}}
              </v-btn>
              <v-btn @click="nextmonth()">
                {{$t('NextMount')}}
                <v-icon right dark>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="hidden-sm-and-up">
          <v-layout row wrap>
            <v-flex md4 xs12 class="text-sm-left text-xs-left">
              <v-btn @click="todaybutton()" color="#039BE5" style="color:#fff;">
                <v-icon dark left color="#fff;">far fa-calendar-check</v-icon>
                {{$t('Today')}}
              </v-btn>
              <v-btn @click="prevmonth()">
                <v-icon dark left>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-btn @click="nextmonth()">
                <v-icon right dark>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="success" @click="process()">
               <v-icon class="pr-2" size="16">fa-spinner</v-icon>
              <span>{{$t('processor')}}</span>
            </v-btn>
          </v-flex> 
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="info" @click="printTable()">
              <v-icon class="pr-2" size="16">fa-print</v-icon>
              <span>{{$t('print')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="primary" @click="doCopyTable()">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{$t('copy')}}</span>
            </v-btn>
          </v-flex>
         
      </v-layout>-->
      <!-- <v-layout row wrap class="hidden-xs-only content">
          <v-flex xs12>
            <v-btn dark color="teal" @click="checkbutton(0)">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark color="teal" @click="checkbutton(1)">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
          </v-flex>
      </v-layout>-->
      <!-- </v-flex> -->

      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-layout row wrap class="hidden-sm-and-up">
            <v-flex md12 sm12 xs12 v-for="(item, index) in table_datalist" :key="index" @click="''">
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg12 md12 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg10 md10 sm10 xs10 px-5 class="hidden-sm-and-up">
                        <span class="coco-list-label-text content">{{item.code}} :</span>
                        <br />
                        <span>{{item.name}}</span>
                        <br />
                        <span class="coco-list-label-text">
                          {{$t('Department') + ' : '}}
                          <span>{{item.department_name}}</span>
                        </span>
                        <br />
                        <span class="coco-list-label-text">
                          {{$t('Position') + ' : '}}
                          <span>{{item.position}}</span>
                        </span>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 class="hidden-sm-and-up">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="cyan lighten-2"
                            icon
                            flat
                            @click="viewcalendar(item.code)"
                          >
                            <v-icon>fas fa-calendar-alt</v-icon>
                          </v-btn>
                          <span>{{$t('view')}}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 class="hidden-xs-only">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="cyan lighten-2"
                            icon
                            flat
                            @click="viewcalendar(item.code)"
                          >
                            <v-icon>fas fa-calendar-alt</v-icon>
                          </v-btn>
                          <span>{{$t('view')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout class="hidden-xs-only content">
            <v-flex md12 sm12 xs12 class="scroll-able">
              <table id="table_detail" class="table table-bordered coco-sticky-table">
                <thead>
                  <tr
                    style="background-color: #357ca5; color: white;vertical-align: middle"
                    v-html="showheadhtml"
                  ></tr>
                </thead>
                <tbody v-html="showbodyhtml"></tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- FormDialog -->
      <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        v-model="calendarDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{$t('menu.ChangeWorkplanList')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="calendarDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md4>
                  <v-expansion-panel expand>
                    <v-expansion-panel-content
                      style="background-color:#ffffff;margin:0px;"
                      v-for="(date,i) in head_date"
                      :key="i"
                      expand-icon
                    >
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm2 xs3 text-xs-center>
                              <v-icon>fa-calendar-alt</v-icon>
                            </v-flex>

                            <v-flex lg9 md9 sm8 xs6>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                  <span>{{selectedformatDate(date)}}</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>

                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่ วันที่เริ่มงาน hidden-xs-only content-->
                        <div v-for="(time,j) in time" :key="j">
                          <div v-if="date == time.date">
                            <v-layout v-if="time.isProfileHoliday == true">
                              <v-flex text-xs-center row wrap style="text-align:center;background-color:#C5E1A5;">
                                <span>{{time.from}}</span>
                              </v-flex>
                            </v-layout>
                            <v-layout v-else-if="time.isHoliday == true && time.isProfileHoliday == false">
                              <v-flex text-xs-center row wrap style="text-align:center;background-color:#689F38;">
                                <span style="color: #fff;">วันหยุด</span>
                              </v-flex>
                            </v-layout>
                            <v-layout v-else-if="time.processTimePlan != null && time.isProfileHoliday == false" >
                              <v-flex v-if="time.processTimePlan.end_time4 != null" text-xs-center row wrap>
                                <span> {{timeformat(time.processTimePlan.start_time1)}}- {{timeformat(time.processTimePlan.end_time4)}}</span>
                              </v-flex>
                               <v-flex v-else-if="time.processTimePlan.end_time3 != null" text-xs-center row wrap>
                                <span>{{timeformat(time.processTimePlan.start_time1)}} - {{timeformat(time.processTimePlan.end_time3)}}</span>
                              </v-flex>
                               <v-flex v-else-if="time.processTimePlan.end_time2 != null" text-xs-center row wrap>
                                <span>{{timeformat(time.processTimePlan.start_time1)}} - {{timeformat(time.processTimePlan.end_time2)}}</span>
                              </v-flex>
                               <v-flex v-else-if="time.processTimePlan.end_time1 != null" text-xs-center row wrap>
                                <span>{{timeformat(time.processTimePlan.start_time1)}} - {{timeformat(time.processTimePlan.end_time1)}}</span>
                              </v-flex>

                              
                            </v-layout>
                          </div>
                        </div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-flex md12 sm12 xs12>
      <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" />
    </v-flex>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import ProcessService from "@/services/ProcessService";
import PayrollService from "@/services/PayrollService";
import Empimage from "../../components/getempimage.vue";
import FrmDialog from "./FormDialog";
import Utils from "@/utils/";
import XLSX from "xlsx";
import moment from "moment";
import { constants } from "crypto";

export default {
  data: () => ({
    payroll_doc: {
      doc_no: "",
      begin_date: "",
      end_date: "",
      remark: "",
      creator_code: localStorage._usercode
    },
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    snackbarcolor: "red",
    calendarDialog: false,
    emp_code: "",
    filterDialog: false,
    table_datalist: [],
    table_head_model: {
      ชื่อ: "1",
      date: []
    },
    head_date: [],
    json_fields: {
      ชื่อ: "name",
      date: []
    },
    selectitems: [
      { txt: "None", val: "" },
      { txt: "ThisMount", val: 0 },
      { txt: "ThisWeek", val: 1 },
      { txt: "Today", val: 2 },
      { txt: "LastWeek", val: 3 },
      { txt: "LastMount", val: 4 }
    ],
    ChoiceSelected: "",
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8"
        }
      ]
    ],
    buttonlist: 1,
    table_head_count: 1,
    pageActive: 1,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: ""
    },
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    responvalue: "",
    showbodyhtml: "",
    showheadhtml: "",
    bodyHtml: "",
    user_datafinger: [],
    time: [],
    datacheckin: [],
    branch_Select: "",
    department_Select: "",
    from_date: "",
    to_date: "",
    monthname: "",
    month: 0,
    year: ""
  }),
  created: function() {
    this.setShowFilter({
      status: 0
    });
    this.commitSetToolbar({
      patternTool: "1"
    });
    this.$store.watch(
      state => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {},
      {
        deep: true
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    FrmDialog
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "FromDate",
      "ToDate",
      "SearchData"
    ]),
    ...mapState("app", ["showLoading"]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      }
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      }
    }
    // from_date: {
    //   get() {
    //     return this.FromDate;
    //   },
    //   async set(value) {
    //     await this.selectedFormDate({ data: value });
    //   }
    // },
    // to_date: {
    //   get() {
    //     return this.ToDate;
    //   },
    //   async set(value) {
    //     await this.selectedToDate({ data: value });
    //   }
    // }
  },
  methods: {
    ...mapMutations("filter", [
      "setShowFilter",
      "selectedFormDate",
      "selectedToDate",
      "getAllEmployeeByBranch",
      "selectedPosition"
    ]),
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    onCloseDialog() {
      this.dialog_data.status = false;
      //this.getExpensesList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output =
        d.getFullYear() +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day;

      return output;
    },
    viewcalendar(code) {
      var date = "";
      this.calendarDialog = true;
      this.time =[];
      this.table_datalist.forEach(user_finger => {
        if (code == user_finger.code) {
          console.log(user_finger);
          user_finger.processTimes.forEach(element => {
            this.time.push(element);
          });
          console.log("time",this.time);
        }
      });
    },
    showCreateDocDialog() {
      if (
        this.FromDate == "" ||
        this.FromDate == undefined ||
        (this.ToDate == "" || this.FromDate == undefined) ||
        this.SelectBranch == ""
      ) {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาจากวันที่ถึงวันที่";
      } else {
        this.payroll_doc.doc_no = this._docno("PR") + this._docdate();
        this.payroll_doc.begin_date = this.FromDate;
        this.payroll_doc.end_date = this.ToDate;
        this.docDialog = true;
      }
    },
    _docno(head) {
      return (
        head +
        "-xxx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 8) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output =
        d.getFullYear() +
        "" +
        (month < 10 ? "0" : "") +
        month +
        "" +
        (day < 10 ? "0" : "") +
        day +
        hour +
        min;

      return output;
    },
    selectedformatDate(date, format) {
      let lang = localStorage.lang;
      let v = this;
      var Days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var months = ["Jan.","Feb.","Mar.","Apr.","May.","Jun.","Jul.","Aug.","Sep.","Oct.","Nov.","Dec."];
      var DaysTH = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
      var monthsTH = ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."];

      var d = new Date(date),
        month = "" + d.getMonth(),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        days = d.getDay();
      if(lang == 'en'){
        return [Days[days], day, months[month], year].join(" ");
      }  
      else{
        return [DaysTH[days], day, monthsTH[month], year+543].join(" ");
      }
      
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    currentbutton(){
      this.month = 0;
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.from_date = this.selectedformatDates(firstDay);
      this.to_date = this.selectedformatDates(lastDay);
      this.process();
    },
    process() {
      if (this.from_date == "" || this.to_date == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกวันที่";
      } else if (this.branchSelect == "All") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขา";
      } else {
        this.table_head_model.date = [];
        this.head_date = [];
        var start = new Date(this.from_date);
        var end = new Date(this.to_date);

        for (var d = start; d <= end; d.setDate(d.getDate() + 1)) {
          //console.log(this.selectedformatDates(d))
          this.table_head_model.date.push(this.selectedformatDate(d));
          this.head_date.push(this.selectedformatDates(d));
          //console.log(this.table_head_model.date);
        }

        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.SearchData == undefined) {
          searchVal = "";
        } else {
          searchVal = this.SearchData;
        }

        if (this.departmentSelect == "All") {
          this.branch_Select = this.branchSelect;
          this.department_Select = "";
        } else {
          this.branch_Select = this.branchSelect;
          this.department_Select = this.departmentSelect;
        }
        DocumentService.getTimeChecklist(
          this.branch_Select,
          this.department_Select,
          this.emp_code,
          this.from_date,
          this.to_date
        ).then(res => {
          this.datacheckin = res.data;
          console.log(this.datacheckin);
          this.commitSetShowLoading(false);
          this.setShowDetail(this.datacheckin);
          this.table_datalist =[];
           this.datacheckin.forEach(element => {
            if(element.processTimes.length > 0){
                this.table_datalist.push(element);
            }
          });
         
          console.log("gggg",this.table_datalist);
        });
        // console.log(this.datacheckin);
      }
    },
    setShowDetail(response) {
      let ng = this;
      this.footerHtml = "";
      this.responvalue = response;
      this.renderheader();

      response
        .sort(function(a, b) {
          a.code.localeCompare(b.code);
        })
        .sort(function(a, b) {
          a.department_name.localeCompare(b.department_name);
        });
      let retData = ng.groupBy(response, "department_name");
      this.bodyHtml = "";
      for (let item in retData) {
        let departmentHtml = "";
        let rowHtml = "";
        let footerDepartmentHtml = "";
        let departName =
          item.toString() == "" ? "No Department" : item.toString();
        // departmentHtml += this.renderDepartment(departName,response);
        retData[item].forEach(function(employee, i) {
          if (employee.isResign == false) {
            console.log("rowHtml", employee);
            // console.log("checkdata retdata: ", employee);
            rowHtml += ng.renderNormalRow(employee);
          }
        });
        ng.bodyHtml += departmentHtml + rowHtml;
        //console.log("row", ng.bodyHtml);
      }
      this.showbodyhtml = "";
      this.showbodyhtml = ng.bodyHtml;
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    renderNormalRow(item) {
      let empTypeText = "";
      if (item.isResign == false && item.processTimes.length > 0) {
        let htmlz =
          `<tr>` +
          `<td nowrap >` +
          item.department_name +
          `</td>` +
          `<td nowrap >` +
          item.code +
          `</td>` +
          `<td nowrap >` +
          item.name +
          `</td>`;

        if (this.table_head_model.date.length > 0) {
          this.head_date.forEach(time => {
            let processTimeCheckin = "";
            let processTimePlan = "";
            let Holiday = "";
            let Total = "";
            item.processTimes.forEach(checkdate => {
              if (
                time == checkdate.date &&
                checkdate.isProfileHoliday == true
              ) {
                Holiday = checkdate.from;
                htmlz +=
                  `<td nowrap  style="text-align:center;background-color:#C5E1A5;"><br><br><strong>` +
                  Holiday +
                  `</strong></td>`;
              } else if (
                time == checkdate.date &&
                checkdate.isHoliday == true &&
                checkdate.isProfileHoliday == false
              ) {
                htmlz += `<td nowrap style="text-align:center;background-color:#689F38;color:#fff;">วันหยุด</td>`;
              } else if (
                time == checkdate.date &&
                checkdate.processTimePlan != null &&
                checkdate.isProfileHoliday == false
              ) {
                checkdate.processTimePlan;
                if (checkdate.processTimePlan.end_time4 != null) {
                  processTimePlan +=
                    `<div>` +
                      this.timeformat(checkdate.processTimePlan.start_time1) +
                    ` - ` +
                     this.timeformat(checkdate.processTimePlan.end_time4) +
                    `</div>`;
                } else if (checkdate.processTimePlan.end_time3 != null) {
                  processTimePlan +=
                    `<div>` +
                     this.timeformat( checkdate.processTimePlan.start_time1) +
                    ` - ` +
                      this.timeformat(checkdate.processTimePlan.end_time3) +
                    `</div>`;
                } else if (checkdate.processTimePlan.end_time2 != null) {
                  processTimePlan +=
                    `<div>` +
                     this.timeformat(checkdate.processTimePlan.start_time1 )+
                    ` - ` +
                      this.timeformat(checkdate.processTimePlan.end_time2 ) +
                    `</div>`;
                } else if (checkdate.processTimePlan.end_time1 != null) {
                  processTimePlan +=
                    `<div>` +
                     this.timeformat(checkdate.processTimePlan.start_time1 ) +
                    ` - ` +
                      this.timeformat(checkdate.processTimePlan.end_time1 )+
                    `</div>`;
                }

                Holiday = " ";

                htmlz +=
                  `<td nowrap style="text-align:center;">` +
                  processTimePlan +
                  `</td>`;
              }
            });
          });
        }
        htmlz += `</tr>`;

        return htmlz;
      } else {
        let htmlz = ``;
        return htmlz;
      }
    },
    // renderDepartment(departmentName,item) {
    //   let ng = this;
    //   let html = "";
    //   html += `<tr style="background-color:#fcf8e3">`;
    //   html += `<td nowrap colspan='3'>` + departmentName + `</td>`;
    //   for (
    //     var i = 0;
    //     i <
    //     (this.table_head_count == 1
    //       ? this.table_head_count
    //       : this.table_head_count - 2);
    //     i++
    //   ) {
    //     html += `<td style="border-left:0px;border-right:0px;"></td>`;
    //   }

    //   html += `</tr>`;
    //   return html;
    // },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    renderheader() {
      let lang = localStorage.lang;
      this.table_head_count = 1;
      let tableheader = "";
      let ng = this;
     
      if (this.table_head_model.date.length > 0) {
      console.log(lang)
        if(lang == "en"){
        tableheader += `<th nowrap >Department</th>`;
        tableheader += `<th nowrap >Empolyee Code</th>`;
        tableheader += `<th nowrap >Name</th>`;
      }
      else if(lang == "th"){
        tableheader += `<th nowrap >แผนก</th>`;
        tableheader += `<th nowrap >รหัส</th>`;
        tableheader += `<th nowrap >ชื่อ</th>`;
      }
        this.table_head_model.date.forEach(date => {
          this.table_head_count += 1;
          tableheader += `<th nowrap>` + date + `</th>`;
        });
      }
      this.showheadhtml = tableheader;
    },

    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    timeformat(date) {
      return moment(date).format("HH:mm");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },
    printTable() {
      window.print();
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          this.branch_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then(res => {
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    checkbutton(buttonlist) {
      if (buttonlist == 1) {
        this.buttonlist = 1;
        console.log("table");
      } else {
        this.buttonlist = 0;
        console.log("list");
      }
    },
    todaybutton() {
      var curr = new Date();
      this.from_date = this.selectedformatDates(curr);
      this.to_date = this.selectedformatDates(curr);
      this.process();
    },
    prevmonth() {
      var date = new Date();
      this.month = this.month - 1;
      var firstDay = new Date(
        date.getFullYear(),
        date.getMonth() + this.month,
        1
      );
      var lastDay = new Date(
        date.getFullYear(),
        date.getMonth() + this.month + 1,
        0
      );
      this.from_date = this.selectedformatDates(firstDay);
      this.to_date = this.selectedformatDates(lastDay);
      console.log(date.getMonth());
      console.log(this.month);
      console.log(this.from_date);
      console.log(this.to_date);
      this.process();
    },
    nextmonth() {
      var date = new Date();
      this.month = this.month + 1;
      var firstDay = new Date(
        date.getFullYear(),
        date.getMonth() + this.month,
        1
      );
      var lastDay = new Date(
        date.getFullYear(),
        date.getMonth() + this.month + 1,
        0
      );
      this.from_date = this.selectedformatDates(firstDay);
      this.to_date = this.selectedformatDates(lastDay);
      console.log(date.getMonth());
      console.log(this.month);
      console.log(this.from_date);
      console.log(this.to_date);
      this.process();
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>